import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import './Title.css';

class Title extends Component {

  static propTypes = {
    text: PropTypes.string,
    grayText: PropTypes.string,
    className: PropTypes.string,
    textClassName: PropTypes.string,
    grayTextClassName: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    textClassName: '',
    grayTextClassName: '',
  }

  render() {
    const {
      text,
      grayText,
      className,
      textClassName,
      grayTextClassName,
    } = this.props;

    return (
      <div className={`Title ${className}`}>
        {text && (
          <span className={`Title_text ${textClassName}`}>
            {text}
          </span>
        )}
        {grayText && (
          <span className={`Title_grayText ${grayTextClassName}`}>
            {grayText}
          </span>
        )}
      </div>
    );
  }
}

Title.propTypes = {
  text: PropTypes.string,
  grayText: PropTypes.string,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  grayTextClassName: PropTypes.string,
}

Title.defaultProps = {
  className: '',
  textClassName: '',
  grayTextClassName: '',
}

export default Title;



// WEBPACK FOOTER //
// ./src/shared/components/Title/index.js